import { get as lsGet, remove as lsRemove, set as lsSet } from "local-storage";
import constants from "./constants";

const cacheName = constants.CACHE_NAME;

const defaultExpiration = 600000; // 10 minutes

export const createKey = (prefix, params = {}) => `${prefix}:${JSON.stringify(params)}`;

export const getListKeys = (key) => {
  return Object.keys(lsGet(cacheName) || {}).filter((cacheKey) => cacheKey.startsWith(key));
};

export const clearListCache = (key) => {
  getListKeys(key).forEach((cacheKey) => clear(cacheKey));
};

export const set = (key, data, expiration = defaultExpiration) => {
  const cache = lsGet(cacheName) || {};
  cache[key] = {
    data,
    timestamp: new Date().getTime(),
    expiration,
  };
  lsSet(cacheName, cache);
};

export const clear = (key) => {
  const cache = lsGet(cacheName);
  if (cache[key] !== undefined) {
    delete cache[key];
  }
  lsSet(cacheName, cache);
};

export const clearAll = () => lsRemove(cacheName);

export const read = (key) => {
  const cache = lsGet(cacheName);

  if (cache && cache[key]) {
    const prop = cache[key];
    const now = new Date();
    const dif = Math.abs(now.getTime() - prop.timestamp);

    if (prop.data && dif < prop.expiration) {
      return prop.data;
    }
    console.log("cache key expired: " + key);
  }

  console.log("cache key not found: " + key);

  return null;
};

export const get = async (
  key,
  fetchingFunction,
  params,
  expiration = defaultExpiration,
  forceUpdate = false
) => {
  if (!forceUpdate) {
    if (read(key)) {
      return read(key);
    }
  }

  if (fetchingFunction === undefined) {
    return null;
  }

  const res = await fetchingFunction(...params);
  set(key, res, expiration);
  return res;
};
